import { defineComponent as _defineComponent } from 'vue'
import {Converter} from 'showdown';


export default /*#__PURE__*/_defineComponent({
  __name: 'FpMarkdown',
  props: {
    source: { default: '' }
  },
  setup(__props: any) {

const props = __props as { source: string };



const converter: Converter = new Converter();
const html: string = converter.makeHtml(props.source);

return { __sfc: true,props, converter, html }
}

})